import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { DatosSaludGuardados } from "@/components/privacidad/DatosSaludGuardados";

const PUNTOS = [
  ["Lock", "Solo tú accedes a tus datos", "Cada cuenta solo puede ver su propia información. Para entrar necesitas tu correo y contraseña o tu cuenta de Google."],
  ["FileLock2", "Tus documentos son privados", "No se comparten con otros usuarios. Solo se pueden abrir desde tu cuenta."],
  ["Hand", "Tú confirmas las acciones importantes", "AL DÍA propone y organiza. Enviar un correo o guardar cambios importantes siempre lo confirmas tú."],
  ["Bell", "Avisos solo si tú quieres", "Las notificaciones y los permisos del móvil dependen de que los actives. Puedes desactivarlos cuando quieras."],
  ["Sparkles", "Cómo se usa la inteligencia artificial", "Cuando analizas un documento, AL DÍA envía la imagen al servicio de inteligencia artificial Gemini, de Google, a través de nuestro proveedor tecnológico Emergent, solo para leerlo y proponerte cómo organizarlo. El resultado se guarda en tu cuenta. Puedes no utilizar el análisis e introducir los datos manualmente."],
  ["Server", "Dónde se guardan", "Más información disponible en el Aviso de Privacidad."],
  ["UserX", "Puedes eliminar tu cuenta", "Desde el final de esta pantalla puedes eliminar tu cuenta y la información asociada a ella."],
];

// Perfil › Privacidad y seguridad: textos prudentes, sin afirmaciones absolutas.
export const PrivacidadSeguridad = () => (
  <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm" data-testid="privacidad-seguridad">
    <h2 className="font-heading text-lg font-bold text-[#1C2421] flex items-center gap-2">
      <Icons.ShieldCheck size={20} className="text-[#3A6B56]" /> Privacidad y seguridad
    </h2>
    <ul className="mt-4 space-y-4">
      {PUNTOS.map(([icon, titulo, texto], i) => {
        const Icon = Icons[icon] || Icons.Shield;
        return (
          <li key={titulo} className="flex gap-3" data-testid={`privacidad-punto-${i + 1}`}>
            <span className="w-9 h-9 rounded-xl bg-[#E8F0EC] flex items-center justify-center shrink-0"><Icon size={18} className="text-[#3A6B56]" /></span>
            <div>
              <p className="text-base font-semibold text-[#1C2421]">{titulo}</p>
              <p className="text-sm text-[#4A5550] mt-0.5 leading-relaxed">{texto}</p>
            </div>
          </li>
        );
      })}
    </ul>
    <Link to="/privacidad" data-testid="perfil-aviso-privacidad" className="mt-5 min-h-[48px] w-full rounded-xl border border-[#E5DFD5] bg-white px-4 flex items-center justify-between font-semibold text-[#3A6B56]">
      <span className="inline-flex items-center gap-2"><Icons.FileText size={18} /> Aviso de privacidad</span>
      <Icons.ChevronRight size={18} />
    </Link>
    <DatosSaludGuardados />
  </div>
);
